export const common = {
  save: 'Save',
  cancel: 'Cancel',
  confirm: 'Confirm',
  delete: 'Delete',
  edit: 'Edit',
  view: 'View',
  create: 'Create',
  back: 'Back',
  search: 'Search',
  filter: 'Filter',
  export: 'Export',
  import: 'Import',
  refresh: 'Refresh',
  loading: 'Loading...',
  noData: 'No Data',
  success: 'Success',
  error: 'Error',
  required: 'Required',
  optional: 'Optional',
  all: 'All',
  today: 'Today',
  yesterday: 'Yesterday',
  thisWeek: 'This Week',
  thisMonth: 'This Month',
  custom: 'Custom',
  status: 'Status',
  action: 'Action',
  total: 'Total',
  submit: 'Submit',
  reset: 'Reset',
  close: 'Close',
  open: 'Open',
  enable: 'Enable',
  disable: 'Disable',
  yes: 'Yes',
  no: 'No',
  male: 'Male',
  female: 'Female',
  phone: 'Phone',
  email: 'Email',
  address: 'Address',
  name: 'Name',
  date: 'Date',
  time: 'Time',
  description: 'Description',
  note: 'Note',
  settings: 'Settings',
  logout: 'Logout',
  profile: 'Profile',
  help: 'Help',
  about: 'About',
  version: 'Version',
  language: 'Language',
  theme: 'Theme',
  notification: 'Notification',
  message: 'Message',
  alert: 'Alert',
  warning: 'Warning',
  info: 'Info',
  download: 'Download',
  upload: 'Upload',
  copy: 'Copy',
  paste: 'Paste',
  cut: 'Cut',
  selectAll: 'Select All',
  deselectAll: 'Deselect All',
  more: 'More',
  less: 'Less',
  expand: 'Expand',
  collapse: 'Collapse',
  next: 'Next',
  previous: 'Previous',
  finish: 'Finish',
  skip: 'Skip',
  continue: 'Continue',
  pause: 'Pause',
  resume: 'Resume',
  stop: 'Stop',
  start: 'Start',
  retry: 'Retry',
  undo: 'Undo',
  redo: 'Redo',
  clear: 'Clear',
  apply: 'Apply',
  preview: 'Preview',
  print: 'Print',
  share: 'Share',
  like: 'Like',
  favorite: 'Favorite',
  comment: 'Comment',
  reply: 'Reply',
  forward: 'Forward',
  report: 'Report',
  block: 'Block',
  unblock: 'Unblock',
  follow: 'Follow',
  unfollow: 'Unfollow',
  subscribe: 'Subscribe',
  unsubscribe: 'Unsubscribe',
  online: 'Online',
  offline: 'Offline',
  busy: 'Busy',
  away: 'Away',
  active: 'Active',
  inactive: 'Inactive',
  pending: 'Pending',
  approved: 'Approved',
  rejected: 'Rejected',
  completed: 'Completed',
  cancelled: 'Cancelled',
  failed: 'Failed',
  processing: 'Processing',
  waiting: 'Waiting',
  expired: 'Expired',
  draft: 'Draft',
  published: 'Published',
  archived: 'Archived',
  deleted: 'Deleted',
};
